// app/frontend/pages/Home.tsx
import { Button, Group, Container, Box } from "@mantine/core";
import { Link } from "@inertiajs/react";
import { IconSparkles } from "@tabler/icons-react";
import { L2KH1, L2KText, L2KCaption } from "../components/ui/Typography";
import { AnnouncementBanner } from "../components/ui/AnnouncementBanner";
import HybridLayout from "../components/layouts/HybridLayout";
import { SEO } from "../components/common/SEO";
import { HomeHeroBackground } from "../components/ui/HomeHeroBackground";

export default function Home() {
  return (
    <>
      <SEO
        title="Learntokiz — Learn Urbankiz Online with Structured Tracks"
        description="Master urbankiz with expert-led video lessons, learning tracks designed for every level, and a community of dancers. Start free."
      />
      <HomeHeroBackground />
      <Box style={{ position: "relative", zIndex: 1 }}>
        <Container
          size="md"
          className="home-container"
          style={{
            paddingBottom: "clamp(24px, 6vw, 80px)",
          }}
        >
          <AnnouncementBanner
            title="Learntokiz is currently being rebuilt into version 2.0 ✨"
            description="Stay tuned for a fresh learning experience, new features, and improved community tools!"
          />
          <L2KH1
            variant="primary"
            ta="center"
            mb="xl"
            style={{
              marginBottom: "clamp(24px, 5vw, 32px)",
              textShadow:
                "0 2px 20px rgba(0, 0, 0, 0.6), 0 1px 3px rgba(0, 0, 0, 0.8)",
            }}
          >
            Welcome to Learntokiz 2.0
          </L2KH1>

          <L2KText
            size="lg"
            variant="primary"
            fw={500}
            ta="center"
            mb="xl"
            style={{
              maxWidth: "600px",
              margin: "0 auto clamp(32px, 6vw, 50px) auto",
              textShadow:
                "0 2px 16px rgba(0, 0, 0, 0.85), 0 1px 3px rgba(0, 0, 0, 0.9)",
            }}
          >
            Your learning platform for learning urbankiz with more
            customizability and learning tracks!
          </L2KText>

          <Group justify="center" gap="lg" wrap="wrap">
            <Link href="/videos">
              <Button
                size="lg"
                style={{
                  background: "linear-gradient(135deg, #FFC107, #FF9800)",
                  color: "#1a1a1a",
                  fontFamily: "'Big Shoulders Display', sans-serif",
                  fontWeight: 600,
                  border: "none",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  fontSize: "clamp(0.875rem, 3vw, 1rem)",
                  boxShadow:
                    "0 6px 18px rgba(0, 0, 0, 0.35), 0 2px 4px rgba(0, 0, 0, 0.25)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 32px rgba(255, 193, 7, 0.35), 0 4px 10px rgba(0, 0, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(0, 0, 0, 0.35), 0 2px 4px rgba(0, 0, 0, 0.25)";
                }}
              >
                Browse Videos
              </Button>
            </Link>

            <Link href="/dictionary">
              <Button
                variant="outline"
                size="lg"
                style={{
                  borderColor: "#FF9800",
                  color: "#FF9800",
                  fontFamily: "'Big Shoulders Display', sans-serif",
                  fontWeight: 600,
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  fontSize: "clamp(0.875rem, 3vw, 1rem)",
                  background: "rgba(23, 23, 23, 0.4)",
                  backdropFilter: "blur(8px)",
                  boxShadow:
                    "0 6px 18px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.background = "#FF9800";
                  e.currentTarget.style.color = "#F0F0F0";
                  e.currentTarget.style.boxShadow =
                    "0 12px 32px rgba(255, 152, 0, 0.3), 0 4px 10px rgba(0, 0, 0, 0.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "rgba(23, 23, 23, 0.4)";
                  e.currentTarget.style.color = "#FF9800";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)";
                }}
              >
                Dance Dictionary
              </Button>
            </Link>
          </Group>

          <Box
            ta="center"
            mt={{ base: 40, sm: 60 }}
            style={{
              marginTop: "clamp(32px, 6vw, 60px)",
            }}
          >
            <Box
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "clamp(16px, 4vw, 20px) clamp(24px, 6vw, 40px)",
                background: "rgba(0, 0, 0, 0.55)",
                border: "1px solid rgba(255, 152, 0, 0.25)",
                borderRadius: "12px",
                backdropFilter: "blur(10px)",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(0, 0, 0, 0.65)";
                e.currentTarget.style.borderColor = "rgba(255, 152, 0, 0.45)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(0, 0, 0, 0.55)";
                e.currentTarget.style.borderColor = "rgba(255, 152, 0, 0.25)";
              }}
            >
              <IconSparkles
                size={18}
                color="#FF9800"
                style={{ flexShrink: 0 }}
              />
              <L2KCaption variant="secondary" fw={500}>
                Level up your kiz skills and knowledge across 8 modules!
              </L2KCaption>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

Home.layout = (page: React.ReactNode) => (
  <HybridLayout hideOnScroll={true}>{page}</HybridLayout>
);
